(function () {
  const html = document.documentElement;
  const drawer = document.getElementById('CartDrawer');
  if (!drawer) return;

  const panel = drawer.querySelector('.cart-drawer__panel');
  const closeBtn = drawer.querySelector('[data-action="close-cart-drawer"]');
  const cartLinks = Array.from(document.querySelectorAll('.hdr__btn--cart'));

  let removeOutsideClickListener = null;
  let savedScrollPosition = 0;

  function addOutsideClickListener() {
    const handler = (e) => {
      if (!drawer.classList.contains('is-open')) return;
      if (panel && panel.contains(e.target)) return;
      if (e.target.closest && e.target.closest('.hdr__btn--cart')) return;
      if (panel.contains(e.target)) return;
      close();
    };
    document.addEventListener('click', handler, { capture: true });
    return () =>
      document.removeEventListener('click', handler, { capture: true });
  }

  function setCartButtonsAriaExpanded(isExpanded) {
    try {
      cartLinks.forEach((btn) => {
        btn.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      });
    } catch {}
  }

  const setTop = () => {
    const topEl =
      document.querySelector('.site-header__top') ||
      document.querySelector('.site-header');
    const rect = topEl ? topEl.getBoundingClientRect() : { bottom: 0 };
    const h = Math.max(0, Math.round(rect.bottom));
    drawer.style.top = h + 'px';
    drawer.style.height = `calc(100% - ${h}px)`;
    drawer.style.bottom = 'auto';
    panel.style.top = '0px';
    panel.style.height = '100%';
  };
  setTop();
  window.addEventListener('load', setTop);
  window.addEventListener('resize', setTop);
  if ('ResizeObserver' in window) {
    const ro = new ResizeObserver(setTop);
    const headerTop =
      document.querySelector('.site-header__top') ||
      document.querySelector('.site-header');
    headerTop && ro.observe(headerTop);
  }

  const isMobile =
    window.__isMobile ||
    (() => window.matchMedia('(max-width: 1024px)').matches);

  const open = () => {
    drawer.hidden = false;
    drawer.offsetHeight;
    requestAnimationFrame(() => {
      drawer.classList.add('is-open');
    });
    html.classList.add('cart-open');
    if (isMobile()) {
      savedScrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;
      document.body.style.top = `-${savedScrollPosition}px`;
    }
    setCartButtonsAriaExpanded(true);
    if (window.__bringDrawerToFront) window.__bringDrawerToFront(drawer);
    if (removeOutsideClickListener) removeOutsideClickListener();
    removeOutsideClickListener = addOutsideClickListener();
  };
  const close = () => {
    drawer.classList.remove('is-open');
    html.classList.remove('cart-open');
    if (isMobile()) {
      document.body.style.top = '';
      window.scrollTo(0, savedScrollPosition);
    }
    setCartButtonsAriaExpanded(false);
    if (removeOutsideClickListener) {
      removeOutsideClickListener();
      removeOutsideClickListener = null;
    }
    drawer.addEventListener('transitionend', () => (drawer.hidden = true), {
      once: true,
    });
  };

  async function updateInventoryInfo(bodyEl, cartItems) {
    const existingCartItems = document.querySelectorAll(
      '.cart-item[data-available]:not([data-available=""])'
    );
    const inventoryMap = new Map();

    existingCartItems.forEach((el) => {
      const variantId = el.getAttribute('data-variant-id');
      const available = el.getAttribute('data-available');
      const policy = el.getAttribute('data-policy');
      if (variantId && available) {
        inventoryMap.set(variantId, { available, policy });
      }
    });

    const cartItemElements = bodyEl.querySelectorAll('.cart-item');
    cartItemElements.forEach((itemEl) => {
      const variantId = itemEl.getAttribute('data-variant-id');
      const inventoryInfo = inventoryMap.get(variantId);

      if (inventoryInfo) {
        itemEl.setAttribute('data-available', inventoryInfo.available);
        itemEl.setAttribute('data-policy', inventoryInfo.policy);
      }
    });
  }

  const productCache = new Map();

  async function getProductOptions(productHandle) {
    if (productCache.has(productHandle)) {
      return productCache.get(productHandle);
    }

    try {
      const response = await fetch(`/products/${productHandle}.js`);
      const product = await response.json();
      let options = [];
      if (Array.isArray(product.options)) {
        options = product.options.map((opt) =>
          typeof opt === 'string' ? opt : opt.name || String(opt)
        );
      }
      productCache.set(productHandle, options);
      return options;
    } catch (error) {
      return [];
    }
  }

  async function renderCartBody(cart) {
    const bodyEl = drawer.querySelector('.cart-drawer__body');
    const footerEl = drawer.querySelector('.cart-drawer__footer');
    const locale = window.shopLocale || 'en-US';
    if (!bodyEl) return;
    if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) {
      const shopUrl =
        drawer.getAttribute('data-shop-url') || '/collections/all';
      bodyEl.innerHTML = `
        <div class="cart-empty">
          <p class="cart-empty__msg">LOOKS LIKE YOU HAVEN'T ADDED ANYTHING YET,<br>LET'S GET YOU STARTED!</p>
          <a href="${shopUrl}" class="cart-empty__cta">GO TO SHOP</a>
        </div>
      `;
      drawer.classList.add('is-empty');
      if (footerEl) footerEl.style.display = 'none';
      return;
    }

    const productOptionsMap = new Map();
    await Promise.all(
      cart.items.map(async (item) => {
        if (item.handle) {
          const options = await getProductOptions(item.handle);
          productOptionsMap.set(item.product_id, options);
        }
      })
    );

    const itemsHtml = cart.items
      .map((item, idx) => {
        const line = idx + 1;
        const img = item.image
          ? `<img src="${item.image}" alt="${(item.product_title || '').replace(
              /"/g,
              '&quot;'
            )}" width="100" height="100">`
          : '';

        let optionsHtml = '';
        if (item.variant_title && item.variant_title !== 'Default Title') {
          const productOptions = productOptionsMap.get(item.product_id) || [];
          const variantOptions =
            item.options || item.variant_title.split(' / ');

          if (productOptions.length > 0 && Array.isArray(variantOptions)) {
            optionsHtml = productOptions
              .map((optName, idx) => {
                const optValue = variantOptions[idx];
                if (optValue && optValue !== 'Default Title') {
                  return `<div class="cart-item__meta-item">${optName}: ${optValue}</div>`;
                }
                return '';
              })
              .filter((html) => html)
              .join('');
          } else {
            optionsHtml = item.variant_title;
          }
        }

        return `
        <div class="cart-item" data-line="${line}" data-key="${
          item.key
        }" data-variant-id="${
          item.variant_id
        }" data-available="" data-policy="">
          <div class="cart-item__img">${img}</div>
          <div class="cart-item__info">
            <div class="cart-item__title">${item.product_title || ''}</div>
            <div class="cart-item__meta">${optionsHtml}</div>
            <div class="cart-item__price">${(
              item.line_price / 100
            ).toLocaleString(locale, {
              style: 'currency',
              currency: cart.currency || 'JPY',
            })}</div>
            <div class="cart-item__controls">
              <div class="qty-controls" data-line="${line}">
                <button type="button" class="qty-btn" data-action="qty-minus" aria-label="Decrease">−</button>
                <span class="qty-value">${item.quantity}</span>
                <button type="button" class="qty-btn" data-action="qty-plus" aria-label="Increase">+</button>
              </div>
              <button type="button" class="remove-btn" data-action="remove-line" aria-label="Remove" data-line="${line}">REMOVE</button>
            </div>
            <div class="cart-item__error" aria-live="polite"></div>
          </div>
        </div>`;
      })
      .join('');
    bodyEl.innerHTML = itemsHtml;

    await updateInventoryInfo(bodyEl, cart.items);

    const subtotalEl = document.getElementById('CartSubtotal');
    if (subtotalEl && typeof cart.total_price === 'number') {
      try {
        subtotalEl.textContent = (cart.total_price / 100).toLocaleString(
          locale,
          { style: 'currency', currency: cart.currency || 'JPY' }
        );
      } catch {
        subtotalEl.textContent = (cart.total_price / 100).toFixed(2);
      }
    }
    drawer.classList.remove('is-empty');
    if (footerEl) footerEl.style.display = '';
  }

  document.addEventListener('cart:open', async () => {
    try {
      const cart = await fetch('/cart.js', {
        headers: { Accept: 'application/json' },
      }).then((r) => r.json());
      await renderCartBody(cart);
      open();
      if (typeof cart.item_count === 'number') {
        const countElements = document.querySelectorAll('.cart-count');
        countElements.forEach(
          (el) => (el.textContent = String(cart.item_count))
        );
      }
    } catch {
      open();
    }
  });
  document.addEventListener('cart:refresh', async () => {
    try {
      const cart = await fetch('/cart.js', {
        headers: { Accept: 'application/json' },
      }).then((r) => r.json());
      await renderCartBody(cart);
    } catch {}
  });

  cartLinks.forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      if (drawer.classList.contains('is-open')) {
        close();
      } else {
        open();
      }
    });
  });

  closeBtn.addEventListener('click', close);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });

  let cartQueue = Promise.resolve();
  drawer.addEventListener('click', (e) => {
    const minusBtn = e.target.closest('[data-action="qty-minus"]');
    const plusBtn = e.target.closest('[data-action="qty-plus"]');
    const removeBtn = e.target.closest('[data-action="remove-line"]');
    if (!minusBtn && !plusBtn && !removeBtn) return;

    e.preventDefault();
    const triggerBtn = minusBtn || plusBtn || removeBtn;
    triggerBtn.disabled = true;
    const cooldownMs = 300;

    const run = async () => {
      const itemEl = (minusBtn || plusBtn || removeBtn).closest('.cart-item');
      const line = Number(itemEl?.getAttribute('data-line'));
      if (!line) return;

      let quantity = null;
      if (minusBtn || plusBtn) {
        const itemEl = (minusBtn || plusBtn).closest('.cart-item');
        const valEl = itemEl.querySelector('.qty-value');
        const current = Number(valEl?.textContent || '1');
        let next = Math.max(0, current + (plusBtn ? 1 : -1));

        const policy = itemEl.getAttribute('data-policy');
        const availableStr = itemEl.getAttribute('data-available');
        const errEl = itemEl.querySelector('.cart-item__error');

        if (plusBtn) {
          const policy = itemEl.getAttribute('data-policy');
          const availableStr = itemEl.getAttribute('data-available');

          if (policy === 'deny' && availableStr && availableStr !== '') {
            const available = Number(availableStr);
            if (!isNaN(available) && available >= 0 && current >= available) {
              if (errEl) {
                errEl.textContent =
                  window.CartTranslations?.outOfStockApology ||
                  '申し訳ありません。在庫がこれ以上ありません。';
                setTimeout(() => {
                  if (errEl) errEl.textContent = '';
                }, 5000);
              }
              return;
            }
          }

          if (errEl) {
            errEl.textContent = '';
          }
        }
        quantity = next;
      } else if (removeBtn) {
        quantity = 0;
      }

      try {
        const key = itemEl.getAttribute('data-key');
        const params = key
          ? { id: key, quantity: String(quantity) }
          : { line: String(line), quantity: String(quantity) };
        const body = new URLSearchParams(params).toString();
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            Accept: 'application/json',
          },
          credentials: 'same-origin',
          body,
        });

        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }

        let data = await res.json();

        if (data.status && data.status >= 400) {
          throw new Error(data.message || 'Cart update failed');
        }
        const valEl = itemEl.querySelector('.qty-value');
        if (valEl) valEl.textContent = String(quantity);
        if (quantity === 0) itemEl.remove();
        const subtotalEl = document.getElementById('CartSubtotal');
        if (subtotalEl && data && typeof data.total_price === 'number') {
          const locale = window.shopLocale || 'en-US';
          try {
            subtotalEl.textContent = (data.total_price / 100).toLocaleString(
              locale,
              { style: 'currency', currency: data.currency || 'JPY' }
            );
          } catch {
            subtotalEl.textContent = (data.total_price / 100).toFixed(2);
          }
        }

        try {
          const domKey = itemEl.getAttribute('data-key');
          const returnedItem =
            data && Array.isArray(data.items)
              ? data.items.find((i) => i.key === domKey)
              : null;
          const serverQty = returnedItem
            ? Number(returnedItem.quantity)
            : quantity === 0
            ? 0
            : null;
          const errEl = itemEl.querySelector('.cart-item__error');
          const valEl2 = itemEl.querySelector('.qty-value');

          if (plusBtn && serverQty !== null) {
            if (serverQty < quantity) {
              if (valEl2) valEl2.textContent = String(serverQty);
              if (errEl) {
                errEl.textContent =
                  window.CartTranslations?.outOfStockApology ||
                  '申し訳ありません。在庫がこれ以上ありません。';
                setTimeout(() => {
                  if (errEl) errEl.textContent = '';
                }, 5000);
              }
            } else if (errEl) {
              errEl.textContent = '';
            }
          } else if (minusBtn && errEl) {
            errEl.textContent = '';
          }
        } catch (error) {}

        if (!data || typeof data.item_count !== 'number') {
          try {
            data = await fetch('/cart.js', {
              headers: { Accept: 'application/json' },
            }).then((r) => r.json());
          } catch {}
        }

        if (data && typeof data.item_count === 'number') {
          const countElements = document.querySelectorAll('.cart-count');
          countElements.forEach((el) => {
            el.textContent = String(data.item_count);
          });
        }

        try {
          const nowEmpty =
            data &&
            (typeof data.item_count === 'number'
              ? data.item_count === 0
              : Array.isArray(data.items) && data.items.length === 0);
          if (nowEmpty) {
            const bodyEl = drawer.querySelector('.cart-drawer__body');
            const footerEl = drawer.querySelector('.cart-drawer__footer');
            const shopUrl =
              drawer.getAttribute('data-shop-url') || '/collections/all';
            const emptyMessage =
              drawer.getAttribute('data-empty-message') ||
              "LOOKS LIKE YOU HAVEN'T ADDED ANYTHING YET,<br>LET'S GET YOU STARTED!";
            const emptyCta =
              drawer.getAttribute('data-empty-cta') || 'GO TO SHOP';
            if (bodyEl) {
              bodyEl.innerHTML = `
              <div class="cart-empty">
                <p class="cart-empty__msg">${emptyMessage}</p>
                <a href="${shopUrl}" class="cart-empty__cta">${emptyCta}</a>
              </div>
            `;
            }
            drawer.classList.add('is-empty');
            if (footerEl) footerEl.style.display = 'none';
            const countElements = document.querySelectorAll('.cart-count');
            countElements.forEach((el) => {
              el.textContent = '0';
            });
          }
        } catch (err) {}
      } catch (err) {
        const errEl = itemEl.querySelector('.cart-item__error');
        if (errEl && plusBtn) {
          errEl.textContent =
            window.CartTranslations?.outOfStockApology ||
            '申し訳ありません。在庫がこれ以上ありません。';
          setTimeout(() => {
            if (errEl) errEl.textContent = '';
          }, 5000);
        }
      }
    };

    const prev = cartQueue;
    cartQueue = (async function queueTask() {
      try {
        await prev;
        await run();
      } catch (err) {
      } finally {
        setTimeout(() => {
          triggerBtn.disabled = false;
        }, cooldownMs);
      }
    })();
  });

  function checkAndOpenCartFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('viewcart') === 'true') {
      document.dispatchEvent(new CustomEvent('cart:open'));
      if (window.history && window.history.replaceState) {
        const newUrl = new URL(window.location.href);
        newUrl.searchParams.delete('viewcart');
        window.history.replaceState({}, '', newUrl.toString());
      }
      return true;
    }
    return false;
  }

  checkAndOpenCartFromUrl();

  window.addEventListener('load', () => {
    setTimeout(checkAndOpenCartFromUrl, 100);
  });

  document.addEventListener('shopify:section:select', (event) => {
    if (!(window.Shopify && Shopify.designMode)) return;
    const sectionId = event?.detail?.sectionId;
    const selectedSection = sectionId
      ? document.getElementById(`shopify-section-${sectionId}`)
      : document.querySelector('.shopify-section-selected');
    if (!selectedSection) return;

    const sectionType = selectedSection.getAttribute('data-section-type');
    const isCartDrawerSection =
      sectionType === 'cart-drawer' ||
      selectedSection.contains(drawer) ||
      !!selectedSection.querySelector('#CartDrawer');

    if (isCartDrawerSection) {
      document.dispatchEvent(new CustomEvent('cart:open'));
    } else {
      if (drawer.classList.contains('is-open')) {
        close();
      }
    }
  });

  document.addEventListener('shopify:section:deselect', () => {
    if (!(window.Shopify && Shopify.designMode)) return;
    if (drawer.classList.contains('is-open')) {
      close();
    }
  });
})();
